import type { EcommerceShopContext } from '../api/ecommerceAccounts';

export function getSystemShopId(shop: Pick<EcommerceShopContext, 'shop_id'> | null | undefined): string {
  return typeof shop?.shop_id === 'string' ? shop.shop_id.trim() : '';
}

export function isSameShopContext(
  shop: Pick<EcommerceShopContext, 'shop_id' | 'ecom_account_id' | 'platform_account_uid'> | null | undefined,
  shopId: string
): boolean {
  const normalizedShopId = shopId.trim();
  if (!normalizedShopId) {
    return false;
  }

  return [shop?.shop_id, shop?.ecom_account_id, shop?.platform_account_uid]
    .some((value) => typeof value === 'string' && value.trim() === normalizedShopId);
}
